import React from "react";

const Bash_Rm = () => {
  return (
    <div className="p-6 max-w-3xl mx-auto">
      <h2 className="text-2xl font-semibold mb-2">Bash Rm</h2>
      <p>Remove files or directories.</p>
      <h4 className="font-medium mt-4">Syntax</h4>
      <pre><code>rm [options] file</code></pre>
      <h4 className="font-medium mt-4">Examples</h4>
      <pre><code>rm file.txt
rm -r folder/
rm -f file.txt</code></pre>
      <h4 className="font-medium mt-4">Notes</h4>
      <p>Be careful: rm is destructive. Consider using -i for safety.</p>
    </div>
  );
};

export default Bash_Rm;
